import React from 'react';
import './MeetTheFamily.css';

const MeetTheFamily = () => {
  const familyMembers = [
    {
      id: 1,
      name: "Jawed Ali",
      relation: "Father of Mubeen",
      image: "/images/family/raj.jpg",
      description: "Raj is a retired professor who loves gardening and playing chess. He's excited to welcome Mubeen into the family and can't wait to share his famous curry recipes."
    },
    {
      id: 2,
      name: "Farzana Ali",
      relation: "Mother of Mubeen",
      image: "/images/family/priya.jpg",
      description: "Priya is a pediatrician with a passion for classical music. She has been planning this wedding in her head since Anmol was a child and is thrilled to see her dreams come true."
    },
    {
      id: 3,
      name: "Deedar Ali",
      relation: "Father of Anmol",
      image: "/images/family/ahmed.jpg",
      description: "Ahmed is a business owner who enjoys fishing and watching cricket. He's proud of Mubeen and has already accepted Anmol as another child."
    },
    {
      id: 4,
      name: "Nadia Ali",
      relation: "Mother of Anmol",
      image: "/images/family/fatima.jpg",
      description: "Fatima is an artist who specializes in traditional textiles. She has been teaching Anmol family recipes and traditions, creating a beautiful bond between them."
    },
    {
      id: 5,
      name: "Ahad Ali",
      relation: "Brother of Anmol",
      image: "/images/family/vikram.jpg",
      description: "Vikram is Anmol's younger brother and best man. He's a software engineer who has been Anmol's partner in crime since childhood. He's promised not to share too many embarrassing stories in his speech."
    },
    {
      id: 6,
      name: "Safir Ali",
      relation: "Brother of Mubeen",
      image: "/images/family/zara.jpg",
      description: "Zara is Mubeen's older sister and maid of honor. She's a marketing executive who has always been Mubeen's role model and confidante. She's been instrumental in planning the wedding."
    }
  ];
  
  return (
    <div className="page-container family-container">
      <h1>Meet The Ali's</h1>
      <p className="family-intro">
        We're blessed to have the love and support of our wonderful families. Here are the special people who have shaped our lives and will be celebrating with us on our big day.
      </p>
      
      <div className="family-grid">
        {familyMembers.map((member, index) => (
          <div 
            className="family-card" 
            key={member.id}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="family-image">
              <img src={member.image} alt={member.name} />
            </div>
            <div className="family-info">
              <h3>{member.name}</h3>
              <h4>{member.relation}</h4>
              <p>{member.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MeetTheFamily; 